import React from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader'
import Footer from '../components/Footer/Footer'
import WelcomeBanner from '../components/welcomeBanner/WelcomeBanner'
import ContactForm from '../components/contactusForm/ContactForm'


const ContactUs = () => {
    return (
        <>
            <SecondHeader />
            <WelcomeBanner />
            <ContactForm />
            <Footer />
        </>
    )
}

export default ContactUs